import React from 'react'
import  {Grid, TextField, Select, MenuItem, InputLabel,FormControl, makeStyles} from '@material-ui/core'
import { sv } from "date-fns/locale";
import { MuiPickersUtilsProvider, DatePicker, KeyboardDateTimePicker  } from '@material-ui/pickers';
import 'date-fns';
import DateFnsUtils from '@date-io/date-fns';
import moment from 'moment-timezone';
import IntlMessages from 'util/IntlMessages';

const useStyles = makeStyles((theme) => ({
  root: {
      '& .MuiTextField-root': {
          margin: theme.spacing(0),
          //   width: '28ch',
      },
  },
  p0: {
    paddingRight: 0
  },
  labelRoot: {
      marginLeft:0,
  }
}));

export default function CountDownSettings(props) {
  const classes = useStyles()
  return (
    <>
      <Grid item xs="12">
        <MuiPickersUtilsProvider locale={sv} utils={DateFnsUtils}>
          <KeyboardDateTimePicker
              inputVariant="outlined"
              ampm={false}
              cancelLabel={<IntlMessages id="Cancel"/>}
              label={<IntlMessages id="Input.start.label"/>}
              value={props.countStart}
              InputProps={{
                  classes: {
                          adornedEnd: classes.p0
                          }
                  }}
              onChange={props.setCountStart}
              onError={console.log}
              disablePast
              minDateMessage={''}
              fullWidth
              size="small"
              format="yyyy-MM-dd HH:mm"
          />
        </MuiPickersUtilsProvider>
      </Grid>
      <Grid item xs="12">
        <MuiPickersUtilsProvider locale={sv} utils={DateFnsUtils}>
          <KeyboardDateTimePicker
              inputVariant="outlined"
              ampm={false}
              label={<IntlMessages id="Input.Close.label"/>}
              cancelLabel={<IntlMessages id="Cancel"/>}
              value={props.countEnd}
              InputProps={{
                  classes: {
                          adornedEnd: classes.p0
                          }
                  }}
              onChange={props.setCountEnd}
              onError={console.log}
              disablePast
              minDateMessage={''}
              fullWidth
              size="small"
              format="yyyy-MM-dd HH:mm"
          />
        </MuiPickersUtilsProvider>
      </Grid>
    </>
  )
}
